module.exports = __webpack_public_path__ + "static/media/circle-warning.47e8a153.svg";